// getOutdated
export const selectOutdatedSelector = (state) => {
    const { outdated } = state.raceConditions;

    return outdated;
};

// Items returned from submission that need to be updated in cart due to 0 inventory
// This could extend beyond store purchases at some point
// getUpdated
export const selectUpdatedSelector = (state) => {
    const { updated } = state.raceConditions;

    return updated;
};

// getErroredEntities
export const selectErroredEntitiesSelector = (state) => {
    const { erroredEntities } = state.raceConditions;

    return erroredEntities;
};

// getRaceConditions
export const selectAllRaceConditionsSelector = (state) => {
    const { raceConditions } = state;
    return raceConditions;
};
